import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { ReactElement, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetApplicationDataToBankQuery } from "../../../../../store/api/applicationBankApi/applicationBank.api";
import {
  UI_ModuleTextDownCard,
  UI_ModuleTitleCard,
} from "../../../../../UI_ITO/indexUI";
import {
  APPLICATION_BANK_STATUS_KKB,
  BANK_NAME,
} from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../../../../utils/guards/Guard";
import { validateObjectMember } from "../../../../../utils/utilities/validateDataToBank";
import { IndividualCard } from "./IndividualCard/IndividualCard";
import { IndividualCardInfo } from "./IndividualCard/IndividualCardInfo/IndividualCardInfo";

import classes from "./Individuals.module.css";

/**
 * Компонент Individuals отображает информацию о физических лицах и предоставляет возможность добавления новых.
 */
export function Individuals(): ReactElement {
  const [isOpenForm, setIsOpenForm] = useState(false);

  const { applicationId, applicationBankId } = useParams();
  const { data: applicationBank } = useGetApplicationDataToBankQuery({
    applicationId: Number(applicationId),
    applicationBankId: Number(applicationBankId),
  });
  const { data: applicationBankData } = useGetApplicationDataToBankQuery({
    applicationId: Number(applicationId),
    applicationBankId: Number(applicationBankId),
  });

  function openOrCloseForm() {
    setIsOpenForm(!isOpenForm);
  }

  return (
    <div className={classes.individualsWrapper}>
      {applicationBank?.members_fl?.map((individual) => {
        return (
          <IndividualCard
            key={individual.id}
            {...individual}
            isRequiredFields={validateObjectMember(
              individual.member_passport_fl,
              [
                "passport_post_address",
                "passport_url",
                "passport_url_sign",
                "expired_date",
                "passport_document",
              ],
            )}
          />
        );
      })}

      {applicationBankData && (
        <Guard.ApplicationBankStatus
          status={applicationBankData?.status}
          allowedStatuses={[
            {
              bank_name: BANK_NAME.KKB,
              type: APPLICATION_BANK_STATUS_KKB.PROCESSING,
            },
            {
              bank_name: BANK_NAME.KKB,
              type: APPLICATION_BANK_STATUS_KKB.REVISION,
            },
          ]}
        >
          <Button
            block
            icon={<PlusOutlined />}
            onClick={() => openOrCloseForm()}
            disabled={isOpenForm}
            type="primary"
            className={classes.addStaffButton}
            size="large"
          >
            Добавить физическое лицо
          </Button>
        </Guard.ApplicationBankStatus>
      )}
      {isOpenForm && (
        <>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.individualsDivider}
          >
            Создание нового учредителя
          </Divider>
          <div>
            <UI_ModuleTitleCard
              className={classes.individualsCard}
              title={"Новое физическое лицо"}
              textDown={
                <UI_ModuleTextDownCard
                  textDown={[
                    `Сохраните учредителя, чтобы продолжить редактирование!`,
                  ]}
                />
              }
              icon={<></>}
            />
            {isOpenForm && (
              <IndividualCardInfo openOrCloseForm={openOrCloseForm} />
            )}
          </div>
        </>
      )}
    </div>
  );
}
